const approach = {
    title: "BUIHA Training Camps",
    mdcontent: `
    
## Placeholder title
Camps
`,
    };
    export default approach;